// Funções de formatação para o sistema

// Formatar moeda brasileira
export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return 'R$ 0,00';
  }
  
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

// Formatar data brasileira
export const formatDate = (date) => {
  if (!date) return '';
  
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '';
  
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(dateObj);
};

// Formatar data e hora brasileira
export const formatDateTime = (date) => {
  if (!date) return '';
  
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '';
  
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(dateObj);
};

// Formatar número com separadores de milhares
export const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }
  
  return new Intl.NumberFormat('pt-BR').format(value);
};

// Formatar CPF
export const formatCPF = (cpf) => {
  if (!cpf) return '';
  
  const cleaned = cpf.replace(/\D/g, '');
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

// Formatar CNPJ
export const formatCNPJ = (cnpj) => {
  if (!cnpj) return '';
  
  const cleaned = cnpj.replace(/\D/g, '');
  return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

// Formatar telefone
export const formatPhone = (phone) => {
  if (!phone) return '';
  
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  
  return phone;
};

// Formatar CEP
export const formatCEP = (cep) => {
  if (!cep) return '';
  
  const cleaned = cep.replace(/\D/g, '');
  return cleaned.replace(/(\d{5})(\d{3})/, '$1-$2');
};

// Formatar placa de veículo
export const formatPlaca = (placa) => {
  if (!placa) return '';
  
  const cleaned = placa.replace(/\D/g, '');
  if (cleaned.length === 7) {
    return cleaned.replace(/(\d{3})(\d{4})/, '$1-$2');
  }
  
  return placa.toUpperCase();
};

// Formatar status de manutenção
export const formatStatusManutencao = (status) => {
  const statusMap = {
    'agendada': 'Agendada',
    'em_andamento': 'Em Andamento',
    'concluida': 'Concluída',
    'cancelada': 'Cancelada'
  };
  
  return statusMap[status] || status;
};

// Formatar tipo de manutenção
export const formatTipoManutencao = (tipo) => {
  const tipoMap = {
    'preventiva': 'Preventiva',
    'corretiva': 'Corretiva',
    'emergencial': 'Emergencial',
    'revisao': 'Revisão',
    'troca_oleo': 'Troca de Óleo',
    'alinhamento': 'Alinhamento',
    'balanceamento': 'Balanceamento',
    'freios': 'Freios',
    'pneus': 'Pneus',
    'bateria': 'Bateria',
    'ar_condicionado': 'Ar Condicionado',
    'eletrica': 'Elétrica',
    'mecanica': 'Mecânica',
    'pintura': 'Pintura',
    'outros': 'Outros'
  };
  
  return tipoMap[tipo] || tipo;
};

// Formatar perfil de usuário
export const formatPerfil = (perfil) => {
  const perfilMap = {
    'administrador': 'Administrador',
    'supervisor': 'Supervisor',
    'coordenador': 'Coordenador',
    'administrativo': 'Administrativo',
    'financeiro': 'Financeiro',
    'motorista': 'Motorista'
  };
  
  return perfilMap[perfil] || perfil;
};

// Formatar status de ponto
export const formatStatusPonto = (status) => {
  const statusMap = {
    'entrada': 'Entrada',
    'saida': 'Saída',
    'justificado': 'Justificado'
  };
  
  return statusMap[status] || status;
};







